export const FILTER_TYPES = 'configurationTypes';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_BUSINESS_PARTNERS = 'businessPartnerIds';
export const FILTER_EVENTS = 'eventTypes';
export const FILTER_PARTNERS = 'partnerIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_ACTIVITY_TYPES = 'activityTypes';

export const COLUMN_ID = 'id';
export const COLUMN_STATUS = 'status';
export const COLUMN_TYPE = 'configurationType';
export const COLUMN_BUSINESS_PARTNERS = 'businessPartners';
export const COLUMN_AFFILIATES = 'affiliates';
export const COLUMN_REG_PLATFORMS = 'registrationPlatforms';
export const COLUMN_EVENT = 'eventType';
export const COLUMN_ACTIVITY_TYPE = 'activityType';
export const COLUMN_TRAFFIC_TYPE = 'trafficType';

export const COLUMN_APPLICATIONS = 'app';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_LAST_UPDATED = 'updatedDate';
export const COLUMN_CREATED = 'createdDate';

export const ACTION_START = 'start';
export const ACTION_STOP = 'stop';
export const ACTION_DUPLICATE = 'copy';
export const ACTION_EDIT = 'edit';
export const ACTION_REMOVE = 'remove';

export const STATUS_ACTIVE = 1;
export const STATUS_INACTIVE = 2;

export const TYPE_CONVERSION = 1;
export const TYPE_POSTBACK = 2;

export const PERMISSION_ACTION_MANAGE_CONVERSIONS = 37;
